import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
} from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { GroupFilterOptions } from "@/_models/filters/group-filter-options";
import { RadioOption } from "@/components/shared/radio-list/radio-list.component";

@Component({
    selector: "app-risk-insights-filter-topbar",
    templateUrl: "./risk-insights-filter-topbar.component.html",
    styleUrls: ["./risk-insights-filter-topbar.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RiskInsightsFilterTopbarComponent {
    @Input() filterForm: UntypedFormGroup;
    @Input() currentFilters;
    @Input() groupFilterOptions: GroupFilterOptions;
    @Input() userList: RadioOption[];
    @Output() filterButtonClicked: EventEmitter<void> =
        new EventEmitter<void>();

    openFilterMenu() {
        this.filterButtonClicked.emit();
    }

    resetFilter(filterKey: string) {
        const emptyValue = filterKey === "groups" ? [] : "";
        return this.filterForm.get(filterKey)?.setValue(emptyValue);
    }
}
